import { render, staticRenderFns } from "./UserInfoForm.vue?vue&type=template&id=20b0b7c6&scoped=true"
import script from "./UserInfoForm.vue?vue&type=script&lang=js"
export * from "./UserInfoForm.vue?vue&type=script&lang=js"
import style0 from "./UserInfoForm.vue?vue&type=style&index=0&id=20b0b7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0b7c6",
  null
  
)

export default component.exports